<template>
  <div id="user-edit-tab-info">

    <!-- Avatar Row -->
    <div class="vx-row">
      <div class="vx-col w-full">
        <div class="flex items-start flex-col sm:flex-row">
        </div>
      </div>
    </div>

    <!-- Content Row -->
    <div class="vx-row">
      <div class="vx-col md:w-1/2 w-full">
        <label class="vs-input--label">Roles</label>
        <v-select class="w-full" name="role" label="title" v-model="data_local.role" :options="fee_add_data.roles" :dir="$vs.rtl ? 'rtl' : 'ltr'" v-validate="'required'" :clearable="false" />
        <span class="text-danger text-sm"  v-show="errors.has('role')">{{ errors.first('role') }}</span>

        <vs-input class="w-full mt-5" label="Fee" v-model="data_local.fee" v-validate="'required|decimal:2'" name="fee" />
        <span class="text-danger text-sm"  v-show="errors.has('fee')">{{ errors.first('fee') }}</span>
      </div>

      <div class="vx-col md:w-1/2 w-full">
        <label class="vs-input--label">Categories</label>
        <v-select class="w-full" name="categories" label="name" v-model="data_local.categories" :options="fee_add_data.categories" :dir="$vs.rtl ? 'rtl' : 'ltr'" v-validate="'required'" />
        <span class="text-danger text-sm"  v-show="errors.has('categories')">{{ errors.first('categories') }}</span>

        <div class="mt-5" v-if="data_local.role.id === 3">
          <label class="vs-input--label">VIP Fee</label>
          <vs-input class="w-full" name="vipFee" v-model="data_local.vipFee" v-validate="'decimal:2'" />
          <span class="text-danger text-sm"  v-show="errors.has('vipFee')">{{ errors.first('vipFee') }}</span>
        </div>
      </div>
    </div>

    <div class="vx-row">
      <div class="vx-col w-full">
        <div class="mt-8 flex flex-wrap items-center justify-end">
          <vs-button class="ml-auto mt-2" @click="addNewRow">Add Condition</vs-button>
        </div>
      </div>
    </div>

    <vx-card  v-for="(attribute, k) in data_local.attributes" :key="k" class="mt-5">
      <vs-row vs-w="12">
        <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-lg="2" vs-sm="4" vs-xs="12" >
        </vs-col>
        <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-lg="8" vs-sm="4" vs-xs="12">
          <label>State / County</label>
          <vs-switch class="ml-4" v-model="data_local.attributes[k].type"/>
        </vs-col>
        <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-lg="2" vs-sm="4" vs-xs="12">
          <vs-button color="danger" type="border" @click="removeRow(k, attribute)">Remove</vs-button>
        </vs-col>
      </vs-row>
      <div class="vx-row mt-5">
        <div class="vx-col flex-1 mb-2">
          <label class="vs-input--label">States</label>
          <v-select class="mt-4" v-model="data_local.attributes[k].state" :clearable="false" @search="onSearchState($event, k)" :filterable="false" :options="stateOptions[k]" v-validate="'required'" :name="'state'+k" :dir="$vs.rtl ? 'rtl' : 'ltr'">
            <template slot="no-options">
              Type to search states
            </template>
            <template slot="option" slot-scope="stateOption">
              <div class="d-center">
                {{ stateOption.label }}
              </div>
            </template>
            <template slot="selected-option" slot-scope="stateOption">
              <div class="selected d-center">
                {{ stateOption.label }}
              </div>
            </template>
          </v-select>
        </div>
        <div class="vx-col flex-1 mb-2" v-if="data_local.attributes[k].type">
          <label class="vs-input--label">County</label>
          <v-select class="mt-4" v-model="data_local.attributes[k].county" :clearable="false" @search="onSearch($event, k)" multiple :filterable="false" :options="countyOptions[k]" v-validate="'required'" name="county" :dir="$vs.rtl ? 'rtl' : 'ltr'">
            <template slot="no-options">
              Select state and type to search counties
            </template>
            <template slot="option" slot-scope="countyOption">
              <div class="d-center">
                {{ countyOption.label }}
              </div>
            </template>
            <template slot="selected-option" slot-scope="countyOption">
              <div class="selected d-center">
                {{ countyOption.label }}
              </div>
            </template>
          </v-select>
        </div>
        <div class="vx-col flex-1 mb-2">
          <label class="vs-input--label">Valid Till</label>
          <datepicker style="margin-top: 15px" placeholder="Select Date" v-model="data_local.attributes[k].validity" :disabledDates="disabledDates"></datepicker>
        </div>
        <div class="vx-col flex-1 mb-2">
          <label class="vs-input--label">Fee</label>
          <vs-input class="w-full mt-4" :name="'attributesFee'+k" v-model="data_local.attributes[k].fee" v-validate="'required|decimal:2'" />
          <span class="text-danger text-sm"  v-show="errors.has('attributesFee'+k)">{{ errors.first('attributesFee'+k) }}</span>
        </div>
        <div class="vx-col flex-1 mb-2" v-if="data_local.role.id === 3">
          <label class="vs-input--label">VIP Fee</label>
          <vs-input class="w-full mt-4" :name="'attributesVipFee'+k" v-model="data_local.attributes[k].vipFee" v-validate="'decimal:2'" />
          <span class="text-danger text-sm"  v-show="errors.has('attributesVipFee'+k)">{{ errors.first('attributesVipFee'+k) }}</span>
        </div>
      </div>
    </vx-card>

    <!-- Save & Reset Button -->
    <div class="vx-row">
      <div class="vx-col w-full">
        <div class="mt-8 flex flex-wrap items-center justify-end">
          <vs-button class="ml-auto mt-2" @click="save_changes" :disabled="!validateForm">Save Changes</vs-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import vSelect from 'vue-select'
import _ from 'lodash'
import axios from '@/axios.js'
import Datepicker from 'vuejs-datepicker'

import moduleUserManagement from '@/store/user-management/moduleUserManagement.js'

export default {
  components: {
    vSelect,
    Datepicker
  },
  data () {
    return {

      disabledDates: {
        to: new Date(Date.now())
      },

      fee_add_data: {
        categories : [],
        roles : []
      },

      data_local: {
        fee: '',
        vipFee: '',
        categories: '',
        role: '',
        attributes: [
          {
            type : false,
            state : '',
            county : '',
            fee : '',
            vipFee : '',
            validity : ''
          }
        ]
      },

      stateOptions: [],
      countyOptions: []

    }
  },
  computed: {
    validateForm () {
      return !this.errors.any()
    }
  },
  methods: {
    removeRow (index, attribute) {
      const idx = this.data_local.attributes.indexOf(attribute)
      if (idx > -1) {
        this.data_local.attributes.splice(idx, 1)
      }
    },
    fetch_fee_data () {
      this.$store.dispatch('userManagement/fetchFee')
        .then(res => {
          this.fee_add_data.categories = res.data.data.categories
          this.fee_add_data.roles = res.data.data.roles
        })
        .catch(err => {
          if (err.response.status === 404) {
            this.user_not_found = true
            return
          }
          console.error(err)
        })
    },
    save_changes () {
      /* eslint-disable */
      if (!this.validateForm) return

      // Here will go your API call for updating data
      // You can get data in "this.data_local"
      axios
        .post('/api/admin/add/fee', this.data_local)
        .then(res => {
          if(res.data.success) {
            this.$vs.notify({
              title: "Fees Added",
              text: res.data.message,
              color: "success"
            })
            this.$router.push('/admin/settings/fees')
          }else{
            this.$vs.notify({
              title: "Error",
              text: res.data.message,
              iconPack: "feather",
              icon: "icon-alert-circle",
              color: "danger"
            });
          }
        })
        .catch(error => {
          if (error.response.status === 422) {
            if (typeof error.response.data.errors !== "undefined") {
              for (var key in error.response.data.errors) {
                if (error.response.data.errors.hasOwnProperty(key))
                  this.$vs.notify({
                    title: "Error",
                    text: error.response.data.errors[key][0],
                    iconPack: "feather",
                    icon: "icon-alert-circle",
                    color: "danger"
                  })
              }
            }
          }
        })
      /* eslint-enable */
    },
    addNewRow () {
      this.data_local.attributes.push({
        type : false,
        state : '',
        county : '',
        fee : '',
        vipFee : '',
        validity : ''
      })
    },
    onSearchState (search, index) {
      this.searchState(search, index, this)
    },
    onSearch (search, index) {
      this.search(search, index, this)
    },
    searchState: _.debounce((search, index, vm) => {
      if (escape(search) !== '') {
        axios
          .post('/api/admin/get/fee/state',
            {
              state: escape(search)
            })
          .then(res => {
            vm.$set(vm.stateOptions, index, res.data.data)
          })
          .catch(error => {
            console.log(error)
          })
      }
    }, 350),
    search: _.debounce((search, index, vm) => {
      if (vm.data_local.attributes[index].state !== '') {
        const stateCode = vm.data_local.attributes[index].state
        //if state is multiple
        /*vm.data_local.attributes[index].state.forEach(function (item) {
          stateCode.push(item.state_code)
        })*/
        if (escape(search) !== '') {
          axios
            .post('/api/admin/get/fee/counties',
              {
                county: escape(search),
                stateCode
              })
            .then(res => {
              vm.$set(vm.countyOptions, index, res.data.data)
            })
            .catch(error => {
              console.log(error)
            })
        }
      } else {
        vm.$vs.notify({
          title: 'Error',
          text: 'Please select a state',
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'danger'
        })
      }
    }, 350)
  },
  created () {
    // Register Module UserManagement Module
    if (!moduleUserManagement.isRegistered) {
      this.$store.registerModule('userManagement', moduleUserManagement)
      moduleUserManagement.isRegistered = true
    }
    this.fetch_fee_data()
  }
}
</script>
